// extracted by mini-css-extract-plugin
module.exports = {"textBlock":"TextBlock_textBlock__J7Cxo","textArea":"TextBlock_textArea__25HYo","moreBtn":"TextBlock_moreBtn__3xCJ-"};